export const CONTRACTS_ROUTES = {
  CONTRACTS: "/contracts",
  CONTRACTS_AGREEMENTS: "/contracts",
  CONTRACTS_TEMPLATES: "/contracts/templates",
} as const;

export type ContractsRouteKey = keyof typeof CONTRACTS_ROUTES;
